export const actions = {
  HISTORIAL_STOCKS_LOAD_REQUESTED: 'HISTORIAL_STOCKS_LOAD_REQUESTED',
  HISTORIAL_STOCKS_LOAD_SUCCEEDED: 'HISTORIAL_STOCKS_LOAD_SUCCEEDED',
  HISTORIAL_STOCKS_LOAD_FILED: 'HISTORIAL_STOCKS_LOAD_FILED',

  HISTORIAL_STOCK_UPDATE_REQUESTED: 'HISTORIAL_STOCK_UPDATE_REQUESTED',
  HISTORIAL_STOCK_UPDATE_SUCCEEDED: 'HISTORIAL_STOCK_UPDATE_SUCCEEDED',
  HISTORIAL_STOCK_UPDATE_FILED: 'HISTORIAL_STOCK_UPDATE_FILED',

  HISTORIAL_STOCK_INSERT_REQUESTED: 'HISTORIAL_STOCK_INSERT_REQUESTED',
  HISTORIAL_STOCK_INSERT_SUCCEEDED: 'HISTORIAL_STOCK_INSERT_SUCCEEDED',
  HISTORIAL_STOCK_INSERT_FILED: 'HISTORIAL_STOCK_INSERT_FILED',

  HISTORIAL_STOCK_DELETE_REQUESTED: 'HISTORIAL_STOCK_DELETE_REQUESTED',
  HISTORIAL_STOCK_DELETE_SUCCEEDED: 'HISTORIAL_STOCK_DELETE_SUCCEEDED',
  HISTORIAL_STOCK_DELETE_FILED: 'HISTORIAL_STOCK_DELETE_FILED',
}

export const getHistorialStocksAction = (dispatch, articuloId) => {
  dispatch({
    type: actions.HISTORIAL_STOCKS_LOAD_REQUESTED,
    payload: articuloId,
  })
}

export const onSubmitInsertHistorialStockFormAction = (dispatch, formHistorialStock) => {
  dispatch({
    type: actions.HISTORIAL_STOCK_INSERT_REQUESTED,
    payload: formHistorialStock,
  })
}

export const onSubmitUpdateHistorialStockFormAction = (dispatch, formHistorialStock) => {
  dispatch({
    type: actions.HISTORIAL_STOCK_UPDATE_REQUESTED,
    payload: formHistorialStock,
  })
}

export const deletePaisAction = (dispatch, id) => {
  dispatch({
    type: actions.HISTORIAL_STOCK_DELETE_REQUESTED,
    payload: id,
  })
}
